import React from "react";
import { Logo } from "./index";

export const LogoExamples: React.FC = () => {
  return (
    <div className="p-6 space-y-8 bg-white rounded-lg shadow-sm">
      <div>
        <h2 className="text-lg font-medium mb-4 text-terracotta">
          Logo Component - Different Sizes
        </h2>
        <div className="flex flex-col space-y-6">
          <div className="flex items-center">
            <span className="w-20 text-emerald-700 font-medium">XS:</span>
            <Logo size="xs" />
          </div>
          <div className="flex items-center">
            <span className="w-20 text-emerald-700 font-medium">SM:</span>
            <Logo size="sm" />
          </div>
          <div className="flex items-center">
            <span className="w-20 text-emerald-700 font-medium">MD:</span>
            <Logo size="md" />
          </div>
          <div className="flex items-center">
            <span className="w-20 text-emerald-700 font-medium">LG:</span>
            <Logo size="lg" />
          </div>
          <div className="flex items-center">
            <span className="w-20 text-emerald-700 font-medium">XL:</span>
            <Logo size="xl" />
          </div>
        </div>
      </div>

      <div>
        <h2 className="text-lg font-medium mb-4 text-terracotta">
          Logo Component - Different Modes
        </h2>
        <div className="flex flex-col space-y-6">
          <div className="flex items-center">
            <span className="w-40 text-emerald-700 font-medium">
              Image Only:
            </span>
            <Logo size="md" imageOnly />
          </div>
          <div className="flex items-center">
            <span className="w-40 text-emerald-700 font-medium">
              Text Only:
            </span>
            <Logo size="md" textOnly />
          </div>
        </div>
      </div>

      <div>
        <h2 className="text-lg font-medium mb-4 text-terracotta">
          Logo Component - Custom Colors
        </h2>
        <div className="flex flex-col space-y-6">
          <div className="flex items-center">
            <span className="w-40 text-emerald-700 font-medium">Purple:</span>
            <Logo size="md" textClassName="text-purple-600" />
          </div>
          <div className="flex items-center">
            <span className="w-40 text-emerald-700 font-medium">Teal:</span>
            <Logo size="md" textClassName="text-teal-600" />
          </div>
          <div className="flex items-center">
            <span className="w-40 text-emerald-700 font-medium">
              Light Green:
            </span>
            <Logo size="md" textClassName="text-lightGreen-600" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LogoExamples;
